module.exports = __webpack_public_path__ + "img/data2.6440118b.svg";